const actions = {
  GET_TEAM_SETTINGS_REQUEST: "GET_TEAM_SETTINGS_REQUEST",
  GET_TEAM_SETTINGS_SUCCESS: "GET_TEAM_SETTINGS_SUCCESS",
  GET_TEAM_SETTINGS_ERROR: "GET_TEAM_SETTINGS_ERROR",

  UPSERT_TEAM_SETTING_REQUEST: "UPSERT_TEAM_SETTING_REQUEST",
  UPSERT_TEAM_SETTING_SUCCESS: "UPSERT_TEAM_SETTING_SUCCESS",
  UPSERT_TEAM_SETTING_ERROR: "UPSERT_TEAM_SETTING_ERROR",

  TOGGLE_SYNC_REQUEST: "TOGGLE_SYNC_REQUEST",
  TOGGLE_SYNC_SUCCESS: "TOGGLE_SYNC_SUCCESS",
  TOGGLE_SYNC_ERROR: "TOGGLE_SYNC_ERROR",

  CLEAR_SETTING_REQUEST: "CLEAR_SETTING_REQUEST",
  CLEAR_SETTING_SUCCESS: "CLEAR_SETTING_SUCCESS",
  CLEAR_SETTING_ERROR: "CLEAR_SETTING_ERROR",

  DELETE_SETTING_REQUEST: "DELETE_SETTING_REQUEST",
  DELETE_SETTING_SUCCESS: "DELETE_SETTING_SUCCESS",
  DELETE_SETTING_ERROR: "DELETE_SETTING_ERROR",

  BULK_SYNC_REQUEST: "BULK_SYNC_REQUEST",
  BULK_SYNC_SUCCESS: "BULK_SYNC_SUCCESS",
  BULK_SYNC_ERROR: "BULK_SYNC_ERROR",

  getTeamSettings: (resolve, reject) => ({
    type: actions.GET_TEAM_SETTINGS_REQUEST,
    payload: { resolve, reject },
  }),

  upsertTeamSetting: (data, resolve, reject) => ({
    type: actions.UPSERT_TEAM_SETTING_REQUEST,
    payload: { data, resolve, reject },
  }),

  toggleSync: (id, data, resolve, reject) => ({
    type: actions.TOGGLE_SYNC_REQUEST,
    payload: { id, data, resolve, reject },
  }),

  deleteSetting: (id, resolve, reject) => ({
    type: actions.DELETE_SETTING_REQUEST,
    payload: { id, resolve, reject },
  }),

  clearSetting: (id, resolve, reject) => ({
    type: actions.CLEAR_SETTING_REQUEST,
    payload: { id, resolve, reject },
  }),

  bulkSync: (id, data, resolve, reject) => ({
    type: actions.BULK_SYNC_REQUEST,
    payload: { id, data, resolve, reject },
  }),
};

export default actions;
